/**
 * Évaluation des mouvements non skiés (marche, attente, montée).
 *
 * Le serveur choisit un mouvement et sa durée ; le client en déduit la
 * position à l'instant affiché. Aucune position n'est envoyée en continu.
 */
import { LIFTS } from './catalog';
import { cableAt, type LiftGeometry } from './lifts';
import type { CableState } from './state';
import type { Vec2 } from './geometry';

/** Vitesse de marche en chaussures de ski (m/s). */
export const WALK_SPEED = 1.6;

export function walkDuration(a: Vec2, b: Vec2): number {
  return Math.max(1, Math.hypot(b[0] - a[0], b[1] - a[1]) / WALK_SPEED);
}

/** Abscisse parcourue sur le brin montant par un passager embarqué en s0. */
export function rideDistance(geo: LiftGeometry, cable: CableState, s0: number, t: number): number {
  const d = cableAt(cable, t) - s0;
  return d < 0 ? 0 : d > geo.up.length ? geo.up.length : d;
}

/** Instant d'arrivée en haut si le câble ne s'arrête pas. */
export function rideArrival(geo: LiftGeometry, cable: CableState, s0: number): number {
  if (cable.v <= 0) return Infinity;
  return cable.t0 + (s0 + geo.up.length - cable.s) / cable.v;
}

/** Prochain passage d'un véhicule au point d'embarquement (abscisse et instant). */
export function nextDeparture(geo: LiftGeometry, cable: CableState, t: number): { s: number; t: number } {
  const s = cableAt(cable, t);
  const k = Math.ceil(s / geo.spacing - 1e-9);
  const sNext = k * geo.spacing;
  return { s: sNext, t: cable.v > 0 ? t + (sNext - s) / cable.v : Infinity };
}

/** Décalage latéral (m) de la place n° seat sur le véhicule, repère local du siège. */
export function seatOffset(geo: LiftGeometry, seat: number): number {
  const seats = LIFTS[geo.kind].seats;
  if (seats === 4) return [-0.9, -0.3, 0.3, 0.9][seat] ?? 0;
  if (seats === 8) return ((seat % 4) - 1.5) * 0.55;
  return 0;
}
